import { logEvent } from "firebase/analytics";
import {
  Grid,
  Typography,
  Button
} from "@mui/material";
import {
  Google as GoogleIcon
} from "@mui/icons-material";
import {
  signInGoogle
} from "../firebase/Authentication-Google";
import { analytics } from "../firebase/Analytics";
import { useStateContext } from "../utils/StateContext";

interface SignInProps {
  readNickname: () => Promise<void>;
  setIsGuest: (isGuest: boolean) => void;
}

function SignIn({
  readNickname,
  setIsGuest
}: SignInProps): JSX.Element {
  const {
    createMessage,
    isRunning,
    setIsRunning,
    isSignIn,
    setIsSignIn
  } = useStateContext();

  const signIn = async (): Promise<void> => {
    setIsRunning(true);
    createMessage("サインイン中...", "info");
    logEvent(analytics, "「サインイン」ボタン押下", {
      app: "maitake-home",
      module: "pages/SignIn.tsx",
      function: "signIn"
    });

    // Googleアカウントでサインインする
    const authResult = await signInGoogle();
    setIsSignIn(authResult);

    if (!authResult) {
      createMessage("サインイン失敗。", "error");
      setIsRunning(false);
      return;
    }

    createMessage("サインイン成功！", "success");
    setIsRunning(false);

    await readNickname();
  }

  return (
    <Grid container
      spacing={2}
      sx={{
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Grid item xs={12}
        sx={{ mt: 8 }}
      >
        <Typography>
          {`Googleアカウントを使用して`}
        </Typography>
        <Typography>
          {`サインインしてね！`}
        </Typography>
      </Grid>

      <Grid item xs={12}
        sx={{ mt: 12 }}
      >
        <Button
          onClick={signIn}
          disabled={isRunning
            || (isSignIn)
          }
          startIcon={<GoogleIcon />}
          variant="contained"
          size="large"
          color="primary"
        >
          {`サインイン`}
        </Button>
      </Grid>

      <Grid item xs={12}
        sx={{ mt: 24 }}
      >
        <Button
          onClick={() => setIsGuest(true)}
          variant="outlined"
          size="small"
          color="inherit"
        >
          {`サインインせず、一部のアプリを利用する`}
        </Button>
      </Grid>
    </Grid>
  );
}

export default SignIn;
